import React, { useContext, useEffect, useState } from "react";
import { DndContext } from "@dnd-kit/core";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import FormBuilderHeader from "./FormBuilderHeader";
import FormDroppable from "./FormCreation/FormDroppable/FormDroppable";
import FormSections from "./FormCreation/FormSections/FormSections";
import FormOptions from "./FormCreation/FormOptions/FormOptions";
import { toast } from "react-toastify";
import { arrayMove } from "@dnd-kit/sortable";
import { useRef } from "react";
import * as Yup from "yup";
import trans, { isRTL } from "../../utils";
import { useFormik } from "formik";
import {
	useAddFormMutation,
	useEditFormMutation,
	useGetSpecificFormQuery,
} from "../../Redux/service/Forms/Form";
import Loader from "../Helpers/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { popupcontext } from "../../context/Popupscontext";
import FormPerview from "./FormPerview";
import { Helmet } from "react-helmet";
import { add } from "lodash";

export default function FormBuilder() {
	const { id } = useParams();
	const [isInitialized, setIsInitialized] = useState(false);
	const { setReloadData, setEdited } = useContext(popupcontext);
	const [formInf, setFormInf] = useState({ name: null, description: null });
	const [droppedItems, setDroppedItems] = useState([]);
	const [activeInput, setActiveInput] = useState("");
	const [others, setOthers] = useState("static");
	const [active, setActive] = useState(false);
	const [submitAttempt, setSubmitAttempt] = useState(false);
	const [activeOption, setActiveOption] = useState("Main");
	const [direction, setDirection] = useState("Main");
	const [preview, setPreview] = useState(false);
	const [addNewForm, { isLoading: AddLoading }] = useAddFormMutation();
	const [editForm, { isLoading: EditLoading }] = useEditFormMutation();
	const [localErrors, setLocalErrors] = useState({});
	const {
		data: Formdata,
		isLoading,
		refetch,
	} = useGetSpecificFormQuery(id, {
		skip: !id,
	});
	const [collapsed, setCollapsed] = useState({
		inputsCollapsed: false,
		optionsCOllapsed: false,
	});
	const dragDataRef = useRef(null);
	useEffect(() => {
		if (Formdata && !isInitialized) {
			setIsInitialized(true);
		}
	}, [Formdata, isInitialized]);
	useEffect(() => {
		if (Formdata && id) {
			Formdata.data.formSchema.fields.map((i) =>
				setDroppedItems((prev) => [...prev, i])
			);
		}
	}, [Formdata, id]);
	const handleDragEnd = (event) => {
		const { active, over } = event;
		if (!over) return;

		const dragData = dragDataRef.current;
		console.log("dragdata", dragData);
		if (!dragData) {
			return;
		}

		// 1. Check if we are reordering at top-level
		const isActiveTop = droppedItems.some((item) => item.key === active.id);
		const isOverTop = droppedItems.some((item) => item.key === over.id);

		if (isActiveTop && isOverTop && active.id !== over.id) {
			const oldIndex = droppedItems.findIndex((item) => item.key === active.id);
			const newIndex = droppedItems.findIndex((item) => item.key === over.id);
			if (oldIndex !== -1 && newIndex !== -1) {
				setDroppedItems((items) => arrayMove(items, oldIndex, newIndex));
			}
			return;
		}

		// 2. Check if it's a nested sort inside same container
		let updated = false;
		setDroppedItems((prev) => {
			const updatedItems = prev.map((parent) => {
				const containerItems = parent.container || [];

				const activeIndex = containerItems.findIndex(
					(item) => item.key === active.id
				);
				const overIndex = containerItems.findIndex(
					(item) => item.key === over.id
				);

				// Reorder only if both are inside this container
				if (activeIndex !== -1 && overIndex !== -1 && active.id !== over.id) {
					updated = true;
					const newContainer = arrayMove(
						containerItems,
						activeIndex,
						overIndex
					);
					return { ...parent, container: newContainer };
				}
				return parent;
			});
			return updated ? updatedItems : prev;
		});
		if (updated) return;
		const activeMatch = active.id.match(/^task-item-(container-.*?)-(.*)$/);
		const overMatch = over.id?.match(/^task-item-(container-.*?)-(.*)$/);

		if (activeMatch && overMatch) {
			const [, activeContainerKey, activeItemKey] = activeMatch;
			const [, overContainerKey, overItemKey] = overMatch;

			if (
				activeContainerKey === overContainerKey &&
				activeItemKey !== overItemKey
			) {
				setDroppedItems((prev) =>
					prev.map((parent) => {
						if (parent.key === activeContainerKey) {
							const list = parent.container || [];
							const oldIndex = list.findIndex((i) => i.key === activeItemKey);
							const newIndex = list.findIndex((i) => i.key === overItemKey);
							if (oldIndex !== -1 && newIndex !== -1) {
								return {
									...parent,
									container: arrayMove(list, oldIndex, newIndex),
								};
							}
						}
						return parent;
					})
				);
				return;
			}
		}
		// 3. Handle new item dropped into container
		const match = over.id.match(/^task-droppable-(container-.*)$/);
		if (match && dragData.name === "Container") {
			toast.info(trans("You can't drop a container into a container"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return;
		}

		const combinedItem = {
			key: active.id,
			name: dragData.name,
			title: dragData.name,
			placeholder: null,
			css: {},
			required: { value: false, validationMessage: "this field is required" },
			radioOptions:
				dragData.name === "Radio_group"
					? [
							{ value: 1, label: `${trans("Option")} 1` },
							{ value: 2, label: `${trans("Option")} 2` },
							{ value: 3, label: `${trans("Option")} 3` },
					  ]
					: null,
			dropdownOptions:
				dragData.name === "Dropdown"
					? {
							queryKey: "static",
							data: [
								{ value: 1, label: `${trans("Option")} 1` },
								{ value: 2, label: `${trans("Option")} 2` },
								{ value: 3, label: `${trans("Option")} 3` },
							],
					  }
					: null,
			inputType: dragData.name === "Input" ? "text" : null,
			btnType: dragData.name === "Button" ? "button" : null,
			hyperLink: null,
			imgPath: null,
			container: dragData.name === "Container" ? [] : null,
		};

		const { container, ...cleanedCombinedItem } = combinedItem;

		if (match) {
			console.log("cleanedCombinedItem", cleanedCombinedItem);
			const matchedKey = match[1];
			setActiveInput(active.id);
			if (cleanedCombinedItem.name !== undefined) {
				setDroppedItems((prev) =>
					prev.map((item) =>
						item.key === matchedKey
							? { ...item, container: [...item.container, cleanedCombinedItem] }
							: item
					)
				);
			}
		} else if (over.id === "task-droppable") {
			setActiveInput(active.id);
			if (combinedItem.name !== undefined)
				setDroppedItems((prev) => [...prev, combinedItem]);
		}
	};
	console.log(droppedItems);
	let initialValues = {
		name: Formdata && id ? Formdata?.data?.name : "",
		description: Formdata && id ? Formdata?.data?.description : "",
		category: Formdata && id ? Formdata?.data?.category : "",
		formSchema: { fields: droppedItems },
	};
	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.test(
				"no-leading-space",
				trans("Name cannot be just whitespace"),
				(value) => {
					if (typeof value !== "string") return false;
					return !/^\s/.test(value);
				}
			)
			.test(
				"no-multiple-spaces",
				trans("Name cannot contain multiple spaces in a row"),
				(value) => {
					if (typeof value !== "string") return false;
					return !/ {2,}/.test(value);
				}
			),
		description: Yup.string().nullable(),
		category: Yup.string().nullable(),
		formSchema: Yup.object({
			fields: Yup.array().of(
				Yup.object({
					title: Yup.string().required(trans("Title is required")),
					required: Yup.object({
						value: Yup.boolean().required(),
						validationMessage: Yup.string().when("value", {
							is: true,
							then: (schema) =>
								schema.required(trans("Validation message is required")),
							otherwise: (schema) => schema.notRequired(),
						}),
					}),
					imgPath: Yup.string().when("name", {
						is: "Image",
						then: (schema) => schema.required(trans("Image path is required")),
						otherwise: (schema) => schema.notRequired(),
					}),

					hyperLink: Yup.string().when("name", {
						is: "Link",
						then: (schema) => schema.required(trans("Link is required")),
						otherwise: (schema) => schema.notRequired(),
					}),

					container: Yup.array()
						.of(
							Yup.object({
								title: Yup.string().required(trans("Title is required")),
								imgPath: Yup.string().when("name", {
									is: "Image",
									then: (schema) =>
										schema.required(trans("Image path is required")),
									otherwise: (schema) => schema.notRequired(),
								}),

								hyperLink: Yup.string().when("name", {
									is: "Link",
									then: (schema) => schema.required(trans("Link is required")),
									otherwise: (schema) => schema.notRequired(),
								}),

								key: Yup.string().required(),
								required: Yup.object({
									value: Yup.boolean().required(),
									validationMessage: Yup.string().when("value", {
										is: true,
										then: (schema) =>
											schema.required(trans("Validation message is required")),
										otherwise: (schema) => schema.notRequired(),
									}),
								}),
							})
						)
						.min(1, trans("Container must contain at least one item"))
						.nullable()
						.notRequired(),
				})
			),
		}),
	});
	const navigate = useNavigate();
	const addForm = useFormik({
		initialValues,
		validationSchema: validSchema,
		enableReinitialize: !isInitialized && Boolean(Formdata),
		onSubmit: async (val) => {
			const errors = await addForm.validateForm();
			console.log("SubmitErrors", errors);
			if (Object.keys(localErrors).length > 0) {
				addForm.setErrors(errors); // show errors in UI
				console.log("❌ Blocked submit because form is invalid", errors);
				return; // ⛔ stop here
			} else {
				if (val.formSchema.fields.length > 0) {
					if (!id) {
						try {
							await addNewForm(val).unwrap();
							toast.success(trans("New Form Is Added"), {
								autoClose: 800,
								rtl: localStorage.getItem("lang") === "ar",
							});
							navigate("/forms/all");
							setReloadData(true);
						} catch (error) {
							toast.error(
								error?.message ||
									error?.data?.message ||
									trans("Something went wrong"),
								{
									autoClose: 800,
									rtl: localStorage.getItem("lang") === "ar",
								}
							);
						}
					} else {
						try {
							console.log("val", val);
							await editForm({ val, id }).unwrap();

							toast.success(trans("Form is edited success"), {
								autoClose: 800,
								rtl: localStorage.getItem("lang") === "ar",
							});
							refetch();
							setReloadData(true);
							setEdited(true);
							navigate("/forms/all");
						} catch (error) {
							toast.error(
								error?.message ||
									error?.data?.message ||
									trans("Something went wrong"),
								{
									autoClose: 800,
									rtl: localStorage.getItem("lang") === "ar",
								}
							);
						}
					}
				} else {
					toast.error(trans("Please add at least one field to the form"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				}
			}
		},
	});
	const handleSubmit = (e) => {
		setSubmitAttempt(true);
		addForm.handleSubmit(e);
	};
	useEffect(() => {
		addForm.setFieldValue("formSchema.fields", droppedItems);
	}, [droppedItems]);
	console.log("DroppedItems", droppedItems);
	useEffect(() => {
		const updateErrors = async () => {
			if (Object.keys(localErrors).length === 0) {
				addForm.setErrors({});
			} else {
				const prevErrors =
					typeof addForm.validateForm === "function"
						? await addForm.validateForm()
						: {};
				addForm.setErrors({ ...prevErrors, ...localErrors });
			}
		};
		updateErrors();
	}, [localErrors]);
	console.log("addForm", addForm);
	console.log("LOCALErrorsBuilder", localErrors);
	if (AddLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	console.log("Active Input", activeInput);
	return (
		<div>
			<Helmet>
				<title>FormBuilder</title>
				<meta name="description" content="FormBuilder" />
			</Helmet>
			<form onSubmit={handleSubmit}>
				<FormBuilderHeader
					addForm={addForm}
					submitAttempt={submitAttempt}
					setActiveOption={setActiveOption}
					setPreview={setPreview}
					dataLength={droppedItems?.length}
				/>

				<DndContext
					autoScroll={true}
					onDragStart={(event) => {
						const dragged = event.active?.data?.current;
						if (dragged) {
							dragDataRef.current = dragged; // Store it manually
							setActiveInput(dragged.id);
							setActive(true);
						}
					}}
					onDragEnd={handleDragEnd}
				>
					<div className="taskbuilder-layout" dir={isRTL ? "rtl" : "ltr"}>
						<FormSections
							collapsed={collapsed}
							formInf={formInf}
							setFormInf={setFormInf}
							items={droppedItems}
							setActiveInput={setActiveInput}
							setActive={setActive}
							addForm={addForm}
							activeOption={activeOption}
							setActiveOption={setActiveOption}
							direction={direction}
							setDirection={setDirection}
						/>
						<div className="task-resizing-arrows">
							{!isRTL ? (
								<SlArrowLeft
									style={{
										width: "24px",
										height: "24px",
										cursor: "pointer",
										transform: collapsed.inputsCollapsed && "rotateY(180deg)",
									}}
									onClick={() =>
										setCollapsed({
											inputsCollapsed: !collapsed.inputsCollapsed,
											optionsCOllapsed: collapsed.optionsCOllapsed,
										})
									}
								/>
							) : (
								<SlArrowRight
									style={{
										width: "24px",
										height: "24px",
										cursor: "pointer",
										transform: collapsed.inputsCollapsed && "rotateY(-180deg)",
									}}
									onClick={() =>
										setCollapsed({
											inputsCollapsed: !collapsed.inputsCollapsed,
											optionsCOllapsed: collapsed.optionsCOllapsed,
										})
									}
								/>
							)}
						</div>
						<FormDroppable
							items={droppedItems}
							setActiveInput={setActiveInput}
							activeInput={activeInput}
							setDroppedItems={setDroppedItems}
							handleDragEnd={handleDragEnd}
							collapsed={collapsed}
							active={active}
							setActive={setActive}
							addForm={addForm}
							submitAttempt={submitAttempt}
							direction={direction}
						/>
						<div className="task-resizing-arrows">
							{!isRTL ? (
								<SlArrowRight
									style={{
										width: "24px",
										height: "24px",
										cursor: "pointer",
										transform: collapsed.optionsCOllapsed && "rotateY(-180deg)",
									}}
									onClick={() =>
										setCollapsed({
											inputsCollapsed: collapsed.inputsCollapsed,
											optionsCOllapsed: !collapsed.optionsCOllapsed,
										})
									}
								/>
							) : (
								<SlArrowLeft
									style={{
										width: "24px",
										height: "24px",
										cursor: "pointer",
										transform: collapsed.optionsCOllapsed && "rotateY(180deg)",
									}}
									onClick={() =>
										setCollapsed({
											inputsCollapsed: collapsed.inputsCollapsed,
											optionsCOllapsed: !collapsed.optionsCOllapsed,
										})
									}
								/>
							)}
						</div>
						<FormOptions
							setDroppedItems={setDroppedItems}
							activeInput={activeInput}
							items={droppedItems}
							setOthers={setOthers}
							others={others}
							addForm={addForm}
							submitAttempt={submitAttempt}
							collapsed={collapsed}
							localErrors={localErrors}
							setLocalErrors={setLocalErrors}
						/>
					</div>
				</DndContext>
			</form>
			<FormPerview
				preview={preview}
				setPreview={setPreview}
				name={addForm?.values?.name}
				data={droppedItems}
			/>
		</div>
	);
}
